import { CreateCustomerFormValues } from '@components/CreateCustomer/components/CreateCustomerForm/CreateCustomerFormDefinitions';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { inboxLocators } from '@locators/inbox';
import strings from '../AddressForm/strings';
import { Form } from '@servicetitan/design-system';
import SuggestedAddress from '../SuggestedAddress';
import useAddressFormManagerContext from '../../context/useAddressFormManagerContext';

/**
 * This component is responsible for rendering the address search input field and displaying suggested address from the input.
 *
 * Renders an input field for searching for an address. When the user types in the input field, a list of suggested addresses will be displayed.
 */
const AddressSearchInput = () => {
  const [showSuggestedAddress, setShowSuggestedAddress] = useState(false);
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext<CreateCustomerFormValues>();
  const { formFieldPrefix } = useAddressFormManagerContext();

  const error =
    errors[formFieldPrefix]?.address?.street?.message ||
    errors[formFieldPrefix]?.address?.unit?.message ||
    errors[formFieldPrefix]?.address?.city?.message ||
    errors[formFieldPrefix]?.address?.state?.message ||
    errors[formFieldPrefix]?.address?.zip?.message
      ? strings.errors.address
      : undefined;

  return (
    <SuggestedAddress
      open={showSuggestedAddress}
      popoverTrigger={
        <Form.Input
          required
          label={strings.labels.address}
          id={inboxLocators.customerSearch.createFormFields.searchForAnAddress}
          placeholder={strings.placeholders.address}
          small
          width='full'
          defaultValue={getValues(`${formFieldPrefix}.address.street`)}
          error={error}
          {...register(`${formFieldPrefix}.address.street`)}
          onFocus={() => setShowSuggestedAddress(true)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setValue(`${formFieldPrefix}.address.street`, e.target.value, {
              shouldDirty: true,
            })
          }
          autoComplete='new-address'
        />
      }
      hideSuggestedAddress={() => setShowSuggestedAddress(false)}
      showManualAddressEntry
    />
  );
};

export default AddressSearchInput;
